module.exports = __webpack_public_path__ + "img/logo.77d1a9cf.png";